// src/services/certificadoService.js
import createAxiosInstance from '../util/axiosInstance';

// Base: /api/certificados
const apiCert = createAxiosInstance('/certificados');

/**
 * GET público /api/certificados/code/:codigo
 * Devuelve el certificado por su código (para verificación QR).
 */
export async function getCertificadoByCodigo(codigo) {
  const c = encodeURIComponent(codigo);
  const { data } = await apiCert.get(`/code/${c}`);
  return data;
}

export default { getCertificadoByCodigo };